import Vue from 'vue'
import App from './App'
import router from './router/'
import store from './store/'
import auth from './auth'

Vue.config.productionTip = false

import { library } from '@fortawesome/fontawesome-svg-core'
import { faUpload, faUserSlash, faBirthdayCake, faBuilding } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faUpload, faUserSlash, faBirthdayCake, faBuilding)

Vue.component('font-awesome-icon', FontAwesomeIcon)

new Vue({
    router,
    store,
    render: h => h(App),

    created() {
        setTimeout(() => {
            this.$store.dispatch('updateLoading', false);
        }, 2000)
    }

}).$mount('#app')
